import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from "../../components/Footer";
import TreatmentsTemplate from '../../components/Treatments-template'
import cosmetic2Img from '../media/cosmetic2.jpg'
import cosmeticImg from '../media/cosmetic.jpg'
import {useTranslation, Trans} from 'react-i18next'

export default function Cosmetic() {
    const { t } = useTranslation();

    return (
        <>
            <Navbar></Navbar>
            <TreatmentsTemplate 
            backgroundImage = {cosmeticImg}
            title = {t('homeSection1Cosm')}
            paragraph = {t('cosmeTitle')}
            addClass = "min-width" 
            mediaContent = 
            {
            `# ${t('cosmeTitle2')}
${t('cosmeParaf')}

![](${cosmetic2Img})
            `
            }
             >
            
            </TreatmentsTemplate>
            <Footer></Footer>
        </>
    )
}
